import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Component as ProductSizeLabel } from '~/shared/components/ProductSizeLabel';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const giftId = config.get('public.productCategories.giftId');
const oneSizeId = config.get('public.productSizeCategory.onesize');

const Wrapper = styled.span``;

const TextWrapper = styled.span`
  color: ${({ theme }) => theme.colors.textFadedAlternate};
`;

const isOneSize = (product) => {
  if ('lineId' in product && !product.masterProductId) {
    return true;
  } else if (product.product_option_id_list) {
    return product.product_option_id_list.includes(oneSizeId);
  } else if (product.productOptionIdList) {
    return product.productOptionIdList.includes(oneSizeId);
  }
  return false;
};

const BasketItemSize = ({ className, isExchange, isMysteryBox, product }) => {
  const isGift = product.defaultProductCategoryId === giftId;

  const sizeLabel = (
    <>
      <TextWrapper>
        <FormattedMessage
          id="global_checkout.size_label"
          defaultMessage="Size"
        />
        {': '}
      </TextWrapper>
    </>
  );

  return (
    <Wrapper className={className}>
      {!isGift && sizeLabel}
      {isExchange ? (
        product.exchangeSizeLabel
      ) : (
        <ProductSizeLabel
          product={product}
          isOneSize={isOneSize(product)}
          isMysteryBox={isMysteryBox}
        />
      )}
    </Wrapper>
  );
};

BasketItemSize.propTypes = {
  className: PropTypes.string,
  isExchange: PropTypes.bool,
  isMysteryBox: PropTypes.bool,
  product: PropTypes.object.isRequired,
};

export default BasketItemSize;
